import {ShopCreaturePanel} from "@/scenes.ui/shop-creature-panel";
import {ShopCreature} from "@/store/shop/types";
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";
import Image = Phaser.GameObjects.Image;

export class OblivioinHeroPanel extends ShopCreaturePanel {

    public static readonly OBLIVION_HERO_PANEL_HEIGHT = 200;

    protected getPanelHeight(): number {
        return OblivioinHeroPanel.OBLIVION_HERO_PANEL_HEIGHT;
    }

    protected getPriceText(sc: ShopCreature): string {
        return String(sc.price);
    }

    protected getBtnIcAtlas(): string | undefined {
        return undefined;
    }

    protected getBtnIcImg(): string {
        return Keys.TOKEN;
    }

    protected afterBackAdded(sc: ShopCreature, data: any) {
        let stand = SpriteUtils.addSprite(this.scene, 70, 165, Keys.ATLAS_BANK_2, 'stand_3').setAlpha(0.8);
        this.add(stand);
    }

    protected createBack(): Image {
        return SpriteUtils.addImage(this.scene, 0, -2, Keys.OBLIVION_BACK, undefined, 1, this.height/this.getPanelHeight())
            .setOrigin(0, 0);
    }

    protected getDescColor(): string {
        return '#aba4a4';
    }

    protected getCreatureX(): number {
        return 72;
    }

    protected getCreatureY(): number {
        return 90;
    }
}